<template>
  <el-dialog title="确认订单" custom-class="vip-pane-modal" :visible.sync="visible" width="650px" append-to-body>
    <div class="order-pane" :class="showTipPane && 'have-tip'" v-loading="initLoading">
      <div class="product-tip-content" v-if="showTipPane">
        <div class="product-tip-title">
          <i class="iconfont icon-viptaocan"></i>
          <span>权益介绍</span>
        </div>
        <div class="product-tip-ul">
          <div class="product-tip-li" v-for="(tipText, tipIndex) in tips" :key="tipIndex">
            <i class="el-icon-check"></i>
            <div class="product-tip-li-text">{{ tipText }}</div>
          </div>
        </div>
      </div>
      <div class="product-title">
        <div>
          <span>购买套餐：</span>
          <span class="is-bold">{{ productInfo.name.split('（')[0] }}VIP</span>
        </div>
        <div :style="{ marginLeft: '80px' }">
          <span>期限：</span>
          <span class="is-bold">{{ productInfo.name.split('（')[1].slice(0, -1) }}</span>
        </div>
      </div>
      <div @click="agree = !agree" :style="{ marginTop: '20px', cursor: 'pointer' }">
        <span class="el-radio" :style="{ marginRight: '5px' }">
          <span class="el-radio__input" :class="agree ? 'is-checked' : ''">
            <span class="el-radio__inner"></span>
          </span>
        </span>
        <span>我已阅读并同意</span>
        <a
          :style="{ color: '#3f6efc', textDecoration: 'none' }"
          @click.stop="downloadCb"
          href="https://xiaobaogong-small-program.oss-cn-shenzhen.aliyuncs.com/小包公用户注册服务协议.docx"
          >《用户注册服务协议》</a
        >
      </div>
      <div class="product-order-info">
        <div class="qrcode-content">
          <div id="qrcode" ref="qrcode"></div>
          <div class="argee-mask" v-show="!agree">
            <div>请先勾选上</div>
            <div>方使用协议</div>
          </div>
        </div>
        <div class="order-info-content">
          <div class="order-tip">
            <img class="wechat-img" :src="wechatImg" />
            <span>微信扫码支付</span>
          </div>
          <div class="order-price">
            <span>应付金额：</span>
            <span class="price-num">￥{{ payPrice.toLocaleString() }}</span>
            <span class="price-tip">支付后可自助开具发票</span>
          </div>
          <div class="order-time">
            <span>订单编号：</span>
            <span>{{ orderNumber || '-' }}</span>
          </div>
          <div class="order-time">
            <span>创建时间：</span>
            <span>{{ createTime | time-filter('YYYY-MM-DD HH:mm:ss') }}</span>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { services } from '@/service';
import QRCode from 'qrcodejs2';

import wechatImg from '@/assets/微信支付@2x.png';

export default {
  data() {
    return {
      wechatImg,
      timeoutController: 0,
      initLoading: false,
      orderId: '',
      orderNumber: '-',
      count: 0,
      createTime: 0,
      payPrice: 0,
      spreadPrice: 0,
      agree: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    productInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    },
    tips() {
      if (this.productInfo.tipArr.length > 0) {
        if (this.productInfo.tipArr.length === 1) {
          return this.productInfo.tipArr[0].tips;
        } else {
          return [
            '类案+法律普通检索',
            '类案+法律高级检索',
            '类案+法律结果中检索',
            '类案+法律明细',
            '类案+法律下载',
            '类案检索报告生成',
            '类案检索报告下载'
          ];
        }
      }
      return [];
    },
    showTipPane() {
      return !!this.tips.length;
    }
  },
  beforeDestroy() {
    this.clearTimeoutHandle();
  },
  mounted() {
    this.getOrderInfo();
  },
  methods: {
    downloadCb() {
      setTimeout(() => {
        this.$message.success('下载成功');
      }, 500);
    },
    clearTimeoutHandle() {
      if (this.timeoutController) {
        clearTimeout(this.timeoutController);
      }
    },
    async getOrderInfo() {
      try {
        this.clearTimeoutHandle();
        this.initLoading = true;

        const params = {
          productId: this.productInfo.id,
          body: `小包公-${this.productInfo.name}`,
          platform: 'pay_platform_company'
        };

        const result = await services.vip.createOrder(params);
        if (result.statusCode !== 1) {
          throw new Error(result.message);
        }

        const { orderInfo, unifiedOrder } = result.data;
        this.clearPayImg();
        new QRCode('qrcode', {
          width: 108,
          height: 108,
          text: unifiedOrder.codeUrl
        });
        this.payPrice = orderInfo.realPrice;
        this.spreadPrice = orderInfo.spreadPrice || 0;
        this.orderId = unifiedOrder.orderId;
        this.createTime = Number(unifiedOrder.timeStamp) * 1000;
        this.orderNumber = unifiedOrder.orderNumber;
        this.checkOrderHandle();
      } catch (err) {
        // this.$error(err);
      } finally {
        this.initLoading = false;
      }
    },
    checkOrderHandle() {
      const orderId = this.orderId;
      if (!orderId) {
        return;
      }
      this.clearTimeoutHandle();
      this.timeoutController = setTimeout(async () => {
        try {
          const result = await services.vip.checkOrder(orderId);
          if (result.statusCode !== 1) {
            throw new Error(result.message);
          }
          const { status } = result.data;
          if (status !== 'SUCCESS') {
            this.checkOrderHandle();
            return;
          }
          this.$message.success('支付成功');
          location.reload();
        } catch (err) {
          this.clearPayImg();
          // this.$error(err);
        }
      }, 1500);
    },
    clearPayImg() {
      const qrcodeEl = document.getElementById('qrcode');
      qrcodeEl && (qrcodeEl.innerHTML = '');
    }
  }
};
</script>

<style lang="less">
.vip-pane-modal {
  .el-dialog__body {
    padding: 30px 20px;
  }

  .el-dialog__header {
    position: relative;
    border-bottom: 0;
    background-color: #3F6EFC;
    padding: 14px 24px;

    .el-dialog__headerbtn {
      top: 18px;
      z-index: 2;
      
      .el-dialog__close {
        color: #fff;
      }
    }

    .el-dialog__title {
      color: #fff;
    }
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 686px;
    height: 52px;
    background: url('../assets/orderModalHeaderImg.png') no-repeat;
    background-size: cover;
    z-index: 1;
  }
}
</style>
<style lang="less" scoped>
.order-pane {
  position: relative;
  padding: 0 10px;

  &.have-tip {
    padding-right: 150px;
  }

  .product-tip-content {
    box-sizing: border-box;
    position: absolute;
    top: -30px;
    right: -20px;
    width: 160px;
    height: calc(100% + 60px);
    background-color: #f8fafd;
    border-left: 1px solid #e8ebef;
    padding: 20px;
    display: flex;
    flex-direction: column;

    .product-tip-title {
      font-size: 14px;
      color: #2c3443;

      .icon-viptaocan {
        color: #ffc400;
        margin-right: 8px;
      }
    }

    .product-tip-ul {
      flex: 1;
      height: 0;
      overflow-x: hidden;
      overflow-y: auto;
      margin-top: 14px;

      &::-webkit-scrollbar {
        display: none;
      }

      .product-tip-li {
        margin-bottom: 12px;
        display: flex;
        align-items: flex-start;

        .el-icon-check {
          font-size: 14px;
          color: #64d306;
          margin-right: 8px;
        }

        .product-tip-li-text {
          flex: 1;
          width: 0;
          font-size: 12px;
          color: #172237;
          line-height: 17px;
        }
      }
    }
  }

  .product-title {
    color: #4E555B;
    font-size: 14px;
    line-height: 22px;
    display: flex;

    .is-bold {
      color: #172237;
      font-weight: bold;
    }
  }

  .spread-price-content {
    color: #9599a5;
    font-size: 14px;
    line-height: 20px;
    margin-top: 15px;
    .spread-price-num {
      color: #ee3131;
    }
  }

  .el-radio {
    .el-radio__inner {
      width: 16px;
      height: 16px;
      border-width: 2px;
    }
  }

  .product-desc-limit {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .product-desc {
    color: #9599a5;
    font-size: 14px;
    line-height: 20px;
    margin-top: 15px;

    .desc-price {
      color: #172237;
    }
  }

  .product-limit {
    color: #9599a5;
    margin-top: 15px;
  }

  .product-order-info {
    display: flex;
    align-items: flex-start;
    min-height: 120px;
    margin-top: 40px;
    color: #172237;
    font-size: 14px;
    line-height: 20px;

    .qrcode-content {
      position: relative;
      box-sizing: border-box;
      width: 120px;
      height: 120px;
      padding: 5px;
      border: 1px solid #dbdfe9;

      #qrcode {
        width: 100%;
      }

      .argee-mask {
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        color: #fff;
        text-align: center;
        font-size: 16px;
        line-height: 24px;
        padding-top: 36px;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 1;
      }
    }

    .order-info-content {
      box-sizing: border-box;
      flex: 1;
      width: 0;
      color: #4E555B;
      font-size: 14px;
      margin-left: 20px;

      .order-tip {
        .wechat-img {
          position: relative;
          top: 1px;
          height: 16px;
          margin-right: 4px;
        }
      }

      .order-price {
        margin-top: 14px;
        vertical-align: bottom;

        .price-num {
          color: #ee3131;
          font-size: 20px;
          line-height: 28px;
        }
        .price-tip {
          color: #9599a5;
          font-size: 12px;
          margin-left: 16px;
        }
      }

      .order-time {
        margin-top: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vipOrder.vue